require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lost-in-virtual-reality.json") })
        }
      }, "path---lost-in-virtual-reality");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lost-in-virtual-reality!./.cache/json/lost-in-virtual-reality.json
// module id = 533
// module chunks = 231608221292675